import { newDateFromUTC, newDateToUTC } from '@bc-library/common'


// DATA RECEIVED FOM API (FROM UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const afterReceiving = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
     return afterReceivingOne(object);
   })
  }
  else if(data.docs && data.count && Array.isArray(data.docs)){
    data.docs = data.docs.map((object:any) => {
      return afterReceivingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = afterReceivingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const afterReceivingOne = (object:any) => {
  if(typeof object == 'object'){

    const data = {
      ...object,
      toBeInvoicedDate: object.toBeInvoicedDate && newDateFromUTC(object.toBeInvoicedDate),
      toBeCollectedDate: object.toBeCollectedDate && newDateFromUTC(object.toBeCollectedDate),
      invoicedDate: object.invoicedDate && newDateFromUTC(object.invoicedDate),
      sentDate: object.sentDate && newDateFromUTC(object.sentDate),
      paidDate: object.paidDate && newDateFromUTC(object.paidDate),
      cancelledDate: object.cancelledDate && newDateFromUTC(object.cancelledDate),
      blockedDate: object.blockedDate && newDateFromUTC(object.blockedDate),
      rejectedDate: object.rejectedDate && newDateFromUTC(object.rejectedDate),
      eInvoicing: object.eInvoicing ? {
        ...object.eInvoicing,
        submittedAt: object.eInvoicing.submittedAt && newDateFromUTC(object.eInvoicing.submittedAt),
      } : object.eInvoicing,
      logs: Array.isArray(object.logs)?object.logs.map((log:any)=>{
        return {
          ...log,
          date: log.date && newDateFromUTC(log.date)
        }
      }):object.logs
    }

    return data;
  }
  return object;
}

// OBJECT FIELDS






// DATA TO BE SENT TO API (TO UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const beforeSending = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
      return beforeSendingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = beforeSendingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const beforeSendingOne = (object:any) => {
  if(typeof object == 'object'){
    const data = {
      ...object,
      date: object.date && newDateToUTC(object.date),
      toBeInvoicedDate: object.toBeInvoicedDate && newDateToUTC(object.toBeInvoicedDate),
      toBeCollectedDate: object.toBeCollectedDate && newDateToUTC(object.toBeCollectedDate),
      invoicedDate: object.invoicedDate && newDateToUTC(object.invoicedDate),
      sentDate: object.sentDate && newDateToUTC(object.sentDate),
      paidDate: object.paidDate && newDateToUTC(object.paidDate),
      cancelledDate: object.cancelledDate && newDateToUTC(object.cancelledDate),
      blockedDate: object.blockedDate && newDateToUTC(object.blockedDate),
      rejectedDate: object.rejectedDate && newDateToUTC(object.rejectedDate),
      logs: Array.isArray(object.logs)?object.logs.map((log:any)=>{
        return {
          ...log,
          date: log.date && newDateToUTC(log.date)
        }
      }):object.logs
    }
    return data;
  }
  return object;
}

// OBJECT FIELDS

